import { render, staticRenderFns } from "./blockDetail.vue?vue&type=template&id=cf2a15d2&scoped=true&"
import script from "./blockDetail.vue?vue&type=script&lang=js&"
export * from "./blockDetail.vue?vue&type=script&lang=js&"
import style0 from "./blockDetail.vue?vue&type=style&index=0&id=cf2a15d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2a15d2",
  null
  
)

export default component.exports